// extracted by mini-css-extract-plugin
module.exports = {"praktik-kinerja-item":"PraktikKinerja_praktik-kinerja-item__n5Dn3"};